module.exports = __webpack_public_path__ + "img/che2.84036658.png";